module.exports = __webpack_public_path__ + "images/stickers/smile@2x.d1638dd5951a29c4d4dd.png";